<div class="text-b1-m-500 text-lg-b1-l-500">Спасибо, специалист с вами свяжется</div>
